import React, { useEffect, useState } from 'react';
import PlaylistView from './PlaylistView';

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Brief skeleton so the loading state is visible before the mock catalog paints. */
function usePreviewLoading(): boolean {
  const [loading, setLoading] = useState(() => !prefersReducedMotion());

  useEffect(() => {
    if (prefersReducedMotion()) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const id = window.setTimeout(() => setLoading(false), 700);
    return () => window.clearTimeout(id);
  }, []);

  return loading;
}

/** Signed-in playlists. Swap `loading` for the API request when it lands. */
const PlaylistPage: React.FC = () => {
  const loading = usePreviewLoading();
  return <PlaylistView loading={loading} />;
};

export default PlaylistPage;
